
<template>
  <div class="select text-right" @click="selectItem()">
    <div v-if="!content" class="placeholder-color">{{placeholder}}</div>
    <div v-else class="content-text">{{content}}</div>
    <van-icon v-if="arrow" class="arrow" name="arrow" />
    <i v-else class="corner"></i>
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Icon, Row, Col, Button } from "vant";
Vue.use(Popup)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Button);

export default {
  name: "zwySelect",
  props: {
    placeHolder: String,
    contentText: String,
    arrow: Boolean
  },
  components: {},
  data() {
    return {
      show: false,
      placeholder: "选择跟进类型",
      content: ""
    };
  },
  mounted() {
    this.placeholder = this.placeHolder;
    this.content = this.contentText;
  },
  watch: {
    placeHolder() {
      this.placeholder = this.placeHolder;
    },
    contentText() {
      this.content = this.contentText;
    }
  },
  methods: {
    selectItem() {
      this.$emit("selectListItem");
    }
  }
};
</script>
<style lang="stylus" scoped>
  .content-text {
    width: 2.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
.corner {
  width: 0px;
  height: 0px;
  border: 4px solid #b4bec7;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  position: absolute;
  right: 0.1rem;
  top: 0.22rem;
}
.arrow {
  position: absolute;
  right: 0.12rem;
  top: 0.16rem;
}
</style>